export const Links = {
  FeatureFlags: {
    EnableInverseCalculation: '/enable-super-secret-inverse-calculation',
  },
  Unauthorized: {
    Home: '/',
    Login: '/login',
    Requisites: '/requisites',
    Privacy: '/privacy',
    UserRegistration: '/register',
    EmailConfirmation: '/confirm-email',
    PasswordForgotten: '/forgot-password',
    PasswordReset: '/reset-password',
    MigrationEmailSent: '/migration-email-sent',
  },
  Authorized: {
    Dashboard: '/',
    NotFound: '/not-found',
    Folder: '/folder/:folderId',
    Recipe: '/folder?/:folderId?/recipe/:recipeId',
    RecipeCalculations: 'calculations',
    RecipeInvestigation: 'investigation',
    ExportRecipes: '/export/:includeInvestigations/:folderId?',
    Materials: '/materials',
    // The selection lives in the URL, so it survives a reload and Back closes the mobile drawer.
    MaterialsWithSelection: '/materials/:materialId?',
    Promocodes: '/promocodes',
    UserProfile: '/profile',
  },
};

type FolderRecipeParams = {
  folderId?: string;
  recipeId: string | number;
};

export const getRecipeRoute = ({ folderId, recipeId }: FolderRecipeParams) =>
  folderId
    ? `/folder/${folderId}/recipe/${recipeId}/calculations`
    : `/recipe/${recipeId}/calculations`;

export const getInvestigationRoute = ({ folderId, recipeId }: FolderRecipeParams) =>
  folderId
    ? `/folder/${folderId}/recipe/${recipeId}/investigation`
    : `/recipe/${recipeId}/investigation`;

export const getFolderRoute = (folderId: string) => `/folder/${folderId}`;

export const getMaterialRoute = (materialId: number | string) => `/materials/${materialId}`;

/** The `:materialId` an empty, not yet created material card carries until its first save. */
export const NEW_MATERIAL_ROUTE_ID = 'new';

export const WITH_INVESTIGATIONS = 'withInvestigations';
const addIncludeInvestiogationsRoot = (includeInvestigations: boolean) =>
  includeInvestigations ? WITH_INVESTIGATIONS : 'withoutInvestigations';

export const getExportFolderRoute = (includeInvestigations: boolean, folderId: string) =>
  `/export/${addIncludeInvestiogationsRoot(includeInvestigations)}/${folderId}`;

export const getExportRoute = (includeInvestigations: boolean) =>
  `/export/${addIncludeInvestiogationsRoot(includeInvestigations)}`;
